import { Navigate, Routes, Route } from "react-router-dom";

import MeetingReportCoachingContent from "./MeetingReportCoachingContent";
import MeetingReportDeepDiveContent from "./MeetingReportDeepDiveContent";
import MeetingReportRecapContent from "./MeetingReportRecapContent";

const MeetingReportContent = () => (
  <Routes>
    <Route index element={<MeetingReportRecapContent />} />
    <Route path="deep-dive" element={<MeetingReportDeepDiveContent />} />
    <Route path="coaching" element={<MeetingReportCoachingContent />} />
    {/* Navigate any non-existent tabs to recap tab */}
    <Route path="*" element={<Navigate to="." />} />
  </Routes>
);

export default MeetingReportContent;
